import { jsx } from "react/jsx-runtime";
import AntTabs from "antd/es/tabs";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import './Tabs.css';/* empty css          */
const Tabs = ({
  className,
  children,
  items,
  addIcon = /* @__PURE__ */ jsx(Icon, { name: "plus", size: 18 }),
  moreIcon = /* @__PURE__ */ jsx(Icon, { name: "moretags", size: 21 }),
  destroyInactiveTabPane = true,
  showOperations = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntTabs,
    {
      addIcon,
      moreIcon,
      destroyInactiveTabPane,
      animated: false,
      items: items == null ? void 0 : items.map(({ label, ...rest }) => ({
        label: /* @__PURE__ */ jsx(
          Typography.Title,
          {
            headingLevel: 5,
            level: "h3",
            color: "dark-light",
            className: classnames("perxis-auto-tabs__item-label"),
            children: label
          }
        ),
        ...rest
      })),
      className: classnames(
        [
          "perxis-auto-tabs",
          {
            "perxis-auto-tabs--hidden-operations": !showOperations
          }
        ],
        className
      ),
      popupClassName: classnames("perxis-auto-tabs-dropdown", className),
      ...props,
      children
    }
  );
};
export {
  Tabs as default
};
//# sourceMappingURL=Tabs.js.map
